import React, { useState } from "react";
import { Button, Popover, Radio, Form, Row, Col } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { loadFormatResultData } from "../../appRedux/actions/Reports";
import IntlMessages from "../../util/IntlMessages";
import { Input } from "reactstrap";
import {MenuUnfoldOutlined } from "@ant-design/icons"
const formatColumnOptions = [
  { label: "By Hour", value: "time" },
  { label: "By Day", value: "day" },
  { label: "By Weekday", value: "weekday" },
  { label: "By Week", value: "firstofweek" },
  { label: "By Month", value: "month" },
  { label: "By Quarter", value: "quarter" },
  { label: "By Year", value: "year" },
];
const formatRowOptions = [
  { label: "Show Totals Only", value: "showtotalsonly" },
  { label: "By Outlet", value: "byoutlet" },
];
const FormatResultFilter = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const isColumnFormat =
    props.isColumnFormat != undefined ? props.isColumnFormat : true;
  //#region useState
  const [getPeriodValue, setPeriodValue] = useState(isColumnFormat ? 'week' : '');
  const [getIsFormatResultPopoverVisible, setIsFormatResultPopoverVisible] =
    React.useState(false);
  const [getFormatOptions, setFormatOptions] = React.useState(
    isColumnFormat ? formatColumnOptions : formatRowOptions
  );
  //#endregion useState

  //#region Use Selector Start Region
  const getReduxFormatResultData = useSelector(
    ({ Reports }) => Reports.formatResultData
  );

  //#endregion Use Selector End Region

  //#region for Use Effect Start Region
  // React.useEffect(() => {
  //   let mounted = true;
  //   if (mounted) {
  //     let jsonObj = {
  //       IsColumnFormat: isColumnFormat,
  //       FormatResultKey: getPeriodValue,
  //     };
  //     dispatch(loadFormatResultData(jsonObj));
  //     return () => (mounted = false);
  //   }
  // }, []);

  //#endregion for Use Effect End Region

  //#region Api Services
  //#endregion Api Services

  //#region onChange Functions

  const handleChangeFormatPeriod = (e) => {
    setPeriodValue(e.target.value);
  };

  const handleClickFormatResultApply = (e) => {
    setIsFormatResultPopoverVisible(false);
    let jsonObj = {
      IsColumnFormat: isColumnFormat,
      FormatResultKey: getPeriodValue,
    };
    dispatch(loadFormatResultData(jsonObj));
    //set redux value here
  };

  //#endregion onChange Functions

  //#region Calculated Functions

  //#endregion

  const radioStyle = {
    display: "block",
    height: "30px",
    lineHeight: "30px",
    fontSize: "18px",
    paddingLeft: "5px",
    marginBottom: "20px",
  };

  const FormatResultOptions = () => {
    return (
      <>
        <div className="dk-label">
          {" "}
          {isColumnFormat ? (
            <IntlMessages id="components.reporting.formatresultfilter.arrangecolumns" />
          ) : (
            <IntlMessages id="components.reporting.formatresultfilter.arrangerows" />
          )}
        </div>
        <Form.Item
          className="ant-form-item-label-custom"
          name={"formatRadio"}
        >
          <Radio.Group
            options={getFormatOptions}
            onChange={(e) => {
              handleChangeFormatPeriod(e);
            }}
            optionType="button"
            size="large"
            style={{display : "flex" ,flexDirection : "column"}} 
            value={getPeriodValue}
          />
        </Form.Item>
      </>
    );
  };

  const FormatResultPopoverContent = (
    <div className="FormatResults-Popover">
      <FormatResultOptions />
      <Row justify="end">
        <Col>
          <IntlMessages id="common.resource.changeformat" />
        </Col>
        <Col onClick={() => setIsFormatResultPopoverVisible(false)}>
          <Form.Item
            className="ant-form-item-label-custom"
          >
            <Button
              form="SearchFormReport"
              htmlType="submit"
              className="ant-btn-primary ml-col-applybtn"
            >
              <IntlMessages id="components.reporting.apply" />
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </div>
  );

  return (
    <>
      <Popover
        // placement="left"
        //  title={promoCodeTitle}
        placement="rightTop"
        content={FormatResultPopoverContent}
        trigger="click"
        onVisibleChange={() => {
          if (!getIsFormatResultPopoverVisible) {
            setPeriodValue(isColumnFormat ? "week" : "showtotalsonly");
          } else {
            setPeriodValue('');
          }
          setIsFormatResultPopoverVisible(!getIsFormatResultPopoverVisible);
        }}
        visible={getIsFormatResultPopoverVisible}
      >
        <Button
    
          className="dk-format-btn dk-btn--text-supplementary"
          icon={<MenuUnfoldOutlined className="dk-btn-icon-align" />}
        >
          <IntlMessages id="common.resource.formatresults" />
        </Button>
      </Popover>
    </>
  );
};

export default FormatResultFilter;
